import { render, staticRenderFns } from "./DevtoolsPage.vue?vue&type=template&id=71bc63d2&"
import script from "./DevtoolsPage.vue?vue&type=script&lang=js&"
export * from "./DevtoolsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports